import { Checkbox, Divider, Stack, TextField } from '@mui/material';
import React from 'react'

function DefaultParamList(props: any) {
    const { heading, defaultParams, handleCheckboxChange, handleParamNameChange , type} = props;
    
    
    
    return (
        <div className='default-params-single-list-wrapper'>

            <div className="default-params-single-list-header">
                {heading}
            </div>
            <Divider/>
            <div className='default-params-single-list'>
                <div>
                    {
                        defaultParams && Object.keys(defaultParams).map((key) => {
                            const active = defaultParams[key].status === "active";
                            return (
                                <Stack direction={"row"} key={key} className='default-parmas-checkbox-wrapper'  >
                                    <Checkbox
                                        checked={active}
                                        onChange={(e) => handleCheckboxChange(e, key,type)}
                                    />
                                    <TextField
                                        disabled={!active}
                                        value={defaultParams[key].name}
                                        label={key}
                                        required
                                        error={defaultParams[key].name.trim() === ""}
                                        onChange={(e) => handleParamNameChange(e, key,type)}
                                    />
                                </Stack>
                            )
                        })
                    }
                </div>
            </div>
        </div>
    )
}

export default DefaultParamList